import React from 'react';
function forwardNameAndTag(name, render) {
    render.displayName = name;
    render.__KONTUR_REACT_UI__ = name;
    render.__KONTUR_ICON__ = true;
    return render;
}
export function forwardRef(name, render) {
    return forwardNameAndTag(name, React.forwardRef(render));
}
